import React from "react";
import BlogOne from "../components/BlogOne";

function BlogOneContainer() {
  return <BlogOne />;
}
export default BlogOneContainer;
